import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { EDITORIAL } from "@/lib/site";

export const MasterStory = () => (
  <section data-testid="master-story" className="relative overflow-hidden bg-charcoal">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 py-20 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-8 lg:py-32">
      <div className="relative">
        <div className="grid grid-cols-5 gap-3">
          <img
            src={EDITORIAL.butcher}
            alt="Usta kasap tezgahı"
            className="col-span-3 aspect-[3/4] w-full border-2 border-cream/10 object-cover"
          />
          <div className="col-span-2 flex flex-col gap-3">
            <img
              src={EDITORIAL.charcuterie}
              alt="Şarküteri seçkisi"
              className="aspect-square w-full border-2 border-cream/10 object-cover"
            />
            <img
              src="/hero-butcher-poster.jpg"
              alt="Premium et kesimi"
              className="aspect-square w-full border-2 border-cream/10 object-cover"
            />
          </div>
        </div>
        <div className="absolute -bottom-5 left-4 flex items-baseline gap-2 border border-copper/40 bg-charcoal px-5 py-3">
          <span className="font-serif text-3xl text-copper">1985</span>
          <span className="font-mono text-[10px] uppercase tracking-wider text-cream/60">bu yana</span>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="mb-5 flex items-center gap-3">
          <span className="h-px w-10 bg-copper" />
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-copper">Ustalık Hikayesi</span>
        </div>
        <h2 className="font-serif text-4xl leading-tight text-cream sm:text-5xl">
          İyi etin tesadüf
          <br />
          <span className="italic text-copper">olmadığına</span> inandık.
        </h2>
        <div className="mt-7 space-y-5 text-base leading-relaxed text-cream/75 sm:text-lg">
          <p>
            1985 yılında başlayan yolculuğumuzda; iyi etin doğru kaynak, sabır ve usta eliyle ortaya
            çıktığına inandık.
          </p>
          <p>
            Her ürünümüzü, kendi soframıza koyacak titizlikle seçer ve hazırlarız. Bizim için kasaplık bir
            meslek değil, kuşaktan kuşağa aktarılan bir zanaattir.
          </p>
        </div>
        <Link
          to="/hakkimizda"
          data-testid="master-story-cta"
          className="mt-9 inline-flex items-center gap-2 border border-copper/50 px-6 py-3 font-mono text-xs uppercase tracking-wider text-copper transition-colors hover:bg-copper hover:text-charcoal"
        >
          Hikayemizi Keşfedin <ArrowRight className="h-4 w-4" />
        </Link>
      </motion.div>
    </div>
  </section>
);

export default MasterStory;
